import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import { Partner } from 'types';
import { State } from 'redux/initialState';

import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';

const InformationalOperationTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationDetailsPage();

  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const partners: Partner[] = data.partners || [];

  const hasData = partners.length > 0;

  return (
    <>
      {hasData ? (
        <tbody>
          {partners.map((partner: Partner, index: number) => (
            <tr
              className="nk-tb-item"
              // eslint-disable-next-line react/no-array-index-key
              key={`informational-partner-row-${index}`}
            >
              <td className="text-left vertical-align-middle pl-2 pl-md-2">
                <Link
                  className="text-primary"
                  to={`/detalle-socio/${actualSociety?._id}/${partner?._id}`}
                >
                  {partner?.name}
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      ) : (
        <EmptyStateForTable
          mainMessage={t('NoDataFound')}
          infoMessage=""
          colspan={1}
        />
      )}
    </>
  );
};

export default InformationalOperationTableBody;
